<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container grid-list-xl pt-0>
		<page-tool-bar
			show_search
			show_month
			:loading="loader"
			:search.sync="search"
			:chosen_month.sync="chosen_month"
		>
			<v-flex shrink>
				<div class="text-right">
					
					<v-btn
						@click="lockPayment"
						:loading="loader"
						:disabled="is_saved_payment || loader"
						color="warning"
					>
						<v-icon small left>
							{{ is_saved_payment ? "lock" : "lock_open"}}
						</v-icon>
						{{ is_saved_payment ? `Đã khóa sổ ` : "Khóa sổ"}}
					</v-btn>
					<!-- In bảng tính tiền -->
					<v-btn
						:disabled="loader"
						@click="print_bill_all = true"
						color="primary"
					>
						<v-icon small left>print</v-icon>
						In hóa đơn
					</v-btn>
					<v-btn
						:disabled="loader"
						@click="print_table = true"
						color="primary"
					>
						<v-icon small left>print</v-icon>
						In sheet 10
					</v-btn>
					<!-- Xuất excel -->
					<v-btn
						:disabled="export_csv.loading ||loader"
						:loading="export_csv.loading"
						@click="exportCSV"
						color="green"
						class="white--text"
					>
						<v-icon small left>archive</v-icon>
						XUẤT EXCEL
						<export-csv-button
							:trigger="export_csv.trigger"
							:title="export_csv.title"
							:rows="export_csv.rows"
						></export-csv-button>
					</v-btn>
					<!-- Nhập csv admin -->
					<import-csv-button  :loader="loader" @uploaded="compareCsvData"></import-csv-button>
					<!-- <export-csv-button
						:trigger="export_csv.trigger"
						:title="export_csv.title"
						:rows="export_csv.rows"
					></export-csv-button> -->
					<!-- <v-checkbox
						v-if="user_role === 'admin'"
						label="Chỉ hiện phòng có chênh lệch"
						v-model="show_only_diff_csv"
						value="value">
					</v-checkbox> -->
				</div>
			</v-flex>
		</page-tool-bar>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-card>
					<!-- <div class="text-xs-right">
						<v-btn @click="lockPayment" :loading="loader" :disabled="is_saved_payment || loader" color="green" :dark="!is_saved_payment" class="mt-3 mb-0">{{ is_saved_payment ? `Tháng ${chosen_month} đã khóa sổ ` : "Click để khóa sổ"}}</v-btn>
						<import-csv-button v-if="user_role === 'admin'" @uploaded="compareCsvData"></import-csv-button>
						<v-btn :loading="export_csv.loading" @click="exportCSV" color="primary" dark>XUẤT EXCEL</v-btn>
						<v-btn @click="print_bill_all = true" color="primary">In bảng tính tiền</v-btn>
					</div> -->
					<v-data-table
						:headers="headers"
						:items="items_filtered" :search="search"
						:rows-per-page-items="rowPerPage"
						disable-initial-sort
						:loading="loader" 
					>
						<!-- <template #headers="props">
							<tr>
								<th :class="['fw-bold sortable', 'text-' + header.align]" v-for="header in props.headers" :key="header.text">
									{{ header.text }}
								</th>
							</tr>
						</template> -->
						<template slot="items" slot-scope="props">
							<tr v-if="items.length" style="cursor: pointer" @click="showDetail(props.item)">
								<td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
								<!-- <td class="text-center text-no-wrap">
									<v-chip
										outline
										:color="status_color[props.item.status].color"
									>
										{{status_color[props.item.status].text}}
									</v-chip>
								</td> -->
								<td class="text-no-wrap">{{ props.item.name }}</td>
								<td class="text-no-wrap text-center">
									<span :class="['v-badge', status_color[props.item.status].color]">
										{{status_color[props.item.status].text}}
									</span>
								</td>
								<td class="text-right text-no-wrap">{{ props.item.total_bill | formatNumber }}</td>
								<td class="text-right text-no-wrap">{{ (props.item.csv_data ? props.item.csv_data.total_bill : 0) | formatNumber }}</td>
								<td class="text-right text-no-wrap">{{ (props.item.csv_data ? props.item.csv_data.diff_total_bill : 0) | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.room_price | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.date_count | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.room_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.electric_price | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.electric.start  }}</td>
								<td class="text-center text-no-wrap">{{ props.item.electric.end  }}</td>
								<td class="text-center text-no-wrap">{{ (props.item.electric.end - props.item.electric.start)  }}</td>
								<td class="text-center text-no-wrap">{{ props.item.electric.total_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.water_price | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.water.start | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.water.end | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ (props.item.water.end - props.item.water.start) | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.water.total_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.trash_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.internet.total_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.motorbike.total_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.bike.total_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.washing_machine.total_bill | formatNumber }}</td>
								<td class="text-center text-no-wrap">{{ props.item.air_conditioner.total_bill | formatNumber }}</td>
								<!-- <td class="text-center text-no-wrap">{{ props.item.collected_amount | formatNumber }}</td> -->
								<!-- <td class="text-center text-no-wrap">{{ props.item.other_amount | formatNumber }}</td> -->
								<!-- <td class="text-center text-no-wrap">{{ props.item.bank_amount | formatNumber }}</td> -->
								<!-- <td class="text-center text-no-wrap">{{ props.item.total_collected | formatNumber }}</td> -->
								<!-- <td class="text-center text-no-wrap">{{ props.item.not_collected | formatNumber }}</td> -->
								<!-- <td class="text-center text-no-wrap">{{ props.item.sum_total | formatNumber }}</td> -->
							</tr>
						</template>
					</v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
	<v-dialog v-if="dialogDetail" v-model="dialogDetail" max-width="fit-content">
        <app-card>
			<app-section-loader :status="loader"></app-section-loader>
			<div class="text-right">
				<v-btn @click="print_bill_detail = true" color="secondary" flat icon>
					<v-icon class="zmdi zmdi-print"></v-icon>
				</v-btn>
				<v-btn @click="refreshPaymentData(chosen_room.room_id)" color="secondary" flat icon>
					<v-icon class="zmdi zmdi-refresh"></v-icon>
				</v-btn>
				<v-btn v-if="is_refreshed" @click="updatePayement" color="primary">Lưu</v-btn>
			</div>
			<room-bill-detail :bill="chosen_room"></room-bill-detail>
        </app-card>
    </v-dialog>
	<print-portal layout="portrait" :open="print_bill_all" @close="print_bill_all = false">
		<print-room-bill :room_data="items"></print-room-bill>
	</print-portal>
	<print-portal layout="landscape" :open="print_table" @close="print_table = false">
		<print-sheet-10 :room_data="items"></print-sheet-10>
	</print-portal>
	<print-portal layout="portrait" :open="print_bill_detail" @close="print_bill_detail = false">
		<room-bill-detail :bill="chosen_room"></room-bill-detail>
	</print-portal>
</div>
</template>

<script>
import api from "Api";
import moment from "moment";
import { buildParamQuery, formatTimeServer } from '../../helpers/helpers';
import { calculateRoomBill, getLastDateOfChosenMonth } from '../../functions'
import RoomBillDetail from '../../components/Bill/RoomBillDetail'
import ImportCsvButton from '../../components/ImportExcel/ImportCsvButton'
import ExportCsvButton from '../../components/ExportExcel/ExportCsvButton'
import PrintPortal from '../../components/Print/PrintPortal'
import PrintRoomBill from '../../components/Print/PrintRoomBill'
import PrintSheet10 from '../../components/Print/PrintSheet10'

export default {
	name: "bang-tinh-tien",
	components: {
		RoomBillDetail,
		ImportCsvButton,
		ExportCsvButton,
		PrintPortal,
		PrintRoomBill,
		PrintSheet10
	},
	data() {
		return {
			loader: false,
			loading: { submit: false },
			menu_month_picker: false,
			headers: [
				{
					text: "Số phòng",
					align: "center",
					value: "room_id",
					sortable: true,
				},
				// { text: "Trạng thái", align: "center", value: "status" },
				{ text: "Họ và tên", align: "left", value: "name" },
				{ text: "Trạng thái", sortable: true, align: "center", value: "status" },
				{ text: "Tổng cộng", sortable: true, align: "right", value: "total_bill" },
				{ text: "Tổng cộng EXCEL", sortable: true, align: "right", value: "csv_data.total_bill", authRequied: false },
				{ text: "Chênh lệch PM-EXCEL", sortable: true, align: "right", value: "csv_data.diff_total_bill", authRequied: false },
				{ text: "Giá phòng", sortable: true, align: "center", value: "room_price" },
				{ text: "Số ngày", sortable: true, align: "center", value: "date_count" },
				{ text: "Tiền phòng", sortable: true, align: "center", value: "room_bill" },
				{ text: "Đơn giá điện", sortable: true, align: "center", value: "electric_price" },
				{ text: "Số điện đầu", sortable: true, align: "center", value: "electric.start" },
				{ text: "Số điện cuối", sortable: true, align: "center", value: "electric.end" },
				{ text: "Lượng điện", sortable: true, align: "center", value: "electric_amount" },
				{ text: "Tiền điện", sortable: true, align: "center", value: "electric.total_bill" },
				{ text: "Đơn giá nước", sortable: true, align: "center", value: "water_price" },
				{ text: "Số nước đầu", sortable: true, align: "center", value: "water.start" },
				{ text: "Số nước cuối", sortable: true, align: "center", value: "water.end" },
				{ text: "Lượng nước", sortable: true, align: "center", value: "water_amount" },
				{ text: "Tiền nước", sortable: true, align: "center", value: "water.total_bill" },
				{ text: "Tiền rác", sortable: true, align: "center", value: "trash" },
				{ text: "Tiền internet", sortable: true, align: "center", value: "internet.total_bill" },
				{ text: "Tiền xe máy", sortable: true, align: "center", value: "motorbike.total_bill" },
				{ text: "Tiền xe đạp", sortable: true, align: "center", value: "bike.total_bill" },
				{ text: "Máy giặt", sortable: true, align: "center", value: "washing_machine.total_bill" },
				{ text: "Máy lạnh", sortable: true, align: "center", value: "air_conditioner.total_bill" },
				// { text: "Thu", align: "center", value: "collected_amount" },
				// { text: "Thu khác", align: "center", value: "other_amount" },
				// { text: "Ngân hàng", align: "center", value: "bank_amount" },
				// { text: "Tổng thu", align: "center", value: "total_collected" },
				// { text: "Chưa thu", align: "center", value: "not_collected" },
				// { text: "Tổng kết", align: "center", value: "sum_total" },
			],
			items: [],
			status_color: {
				"1": {
					text: "Ok",
					color: "primary"
				},
				"-1": {
					text: "Thiếu dữ liệu",
					color: "warning"
				},
			},
			chosen_month: moment().subtract(1, 'months').toISOString().substr(0, 7),
			chosen_building: '',
			chosen_month_locale: '',
			search: "",
			chosen_room: {},
			dialogDetail: false,
			rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
			is_saved_payment: false,
			show_only_diff_csv: false,
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
			},
			print_bill_all: false,
			print_table: false,
			print_bill_detail: false,
			is_refreshed: false
		};
	},
	watch: {
		chosen_month: {
			handler: function (nv){
				this.getPaymentData()
				this.chosen_month_locale = formatTimeServer(nv + '-01')
			},
			immediate: true
		},
		user_role: {
			handler: function (nv) {
				if (nv !== "admin"){
					this.headers = this.headers.filter(header => !header.authRequied)
				}
			},
			immediate: true
		},
		dialogDetail(nv){
			nv ? this.is_refreshed = false : ''
		},
		chosen_room(){
			this.print_bill_detail = false
		}
	},
	computed: {
		user_role(){
			return this.$store.state.auth.role
		},
		items_filtered(){
			return this.items.filter(item => {
				return this.show_only_diff_csv && item.csv_data ? Math.abs(item.csv_data.diff_total_bill) > 30000 : true
			})
		}
	},
	methods: {
		async getPaymentData(){
			this.items = []
			const last_date_of_month = getLastDateOfChosenMonth(this.chosen_month);
            const params = {
				building: this.chosen_building,
				[this.search_type]: this.search,
				lastDateOfMonth: last_date_of_month.toISOString()
            }
            const query = buildParamQuery(params)
			this.loader = true
			let data = await api.getChargeRoom(query)
			this.loader = false
			this.is_saved_payment = data.data.is_saved_payment
			if (this.is_saved_payment){
				this.items = data.data.paymentData.map(room => {
					room.status = this.handleRoomStatus(room)
					return room
				})
			} else {
				this.items = data.data.paymentData.map(bill  => {
					bill.month = this.chosen_month
					bill = calculateRoomBill(bill, this.chosen_month, last_date_of_month)
					bill.status = this.handleRoomStatus(bill)
					return bill
				})
			}
		},
		async refreshPaymentData(room_id){
			const last_date_of_month = getLastDateOfChosenMonth(this.chosen_month);
            const params = {
				building: this.chosen_building,
				lastDateOfMonth: last_date_of_month.toISOString(),
				roomId: room_id,
				isRefresh: true
            }
            const query = buildParamQuery(params)
			this.loader = true
			let data = await api.getChargeRoom(query)
			this.loader = false
			if (data.status == 200 && data.data.paymentData[0]){
				let new_bill = data.data.paymentData[0]
	
				new_bill.month = this.chosen_month
				new_bill = calculateRoomBill(new_bill, this.chosen_month, last_date_of_month)
				new_bill.status = this.handleRoomStatus(new_bill)
				
				this.chosen_room = new_bill
				this.is_refreshed = true
			}
		},
		async updatePayement(){
			const postData = {
				bill: this.chosen_room
			}
			delete postData.bill._id
			delete postData.bill.createdAt
			delete postData.bill.status
			this.loader = true
			const data = await api.updatePayment(postData)
			this.loader = false
			if (data.status == 200) {
				swal.fire("Thành công", data.data.message, "success")
				let found_bill = this.items.find(bill => this.chosen_room.room_id)
				found_bill = data.data.updated_payment
				this.is_refreshed = false;
			} else swal.fire("Lỗi", data.message, "error")
		},
		handleRoomStatus(room){
			let status = 1
			if (
				room.water.end === -1 ||
				room.electric.end === -1 ||
				// !room.electric.start || !room.water.start ||
				!room.electric.end || !room.water.end
			)
				status = -1
			// for (const key in room) {
			// 	if (room.hasOwnProperty(key) && typeof room[key] === 'number') {
			// 		const data = room[key];
			// 		if (data < 0) {
			// 			status = -1
			// 		}
			// 	}
			// }
			return status
		},
        showDetail: async function (room){
			this.dialogDetail = true
            this.chosen_room = room
		},
		async lockPayment(){
			if (!this.validateLockPayment()) return false
			const list_payments = this.items.map((item) => {
				let postData = Object.assign({}, item)
				postData.month = this.chosen_month
				postData.date_created = new Date();
				delete postData._id
				delete postData.createdAt
				delete postData.status
				return postData
			})
			const postData = {
				month: this.chosen_month,
				list_payments
			}
			let that = this
            swal.fire({
            title: 'Khóa sổ',
            text: `Bạn có chắc muốn khóa sổ tháng ${that.chosen_month}?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Khóa sổ',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.loader = true
					that.loading.submit = true
					that.$store.commit('loading', true)

					const data = await api.createPaymentsRoom(postData)

					that.$store.commit('loading', false)
					that.loader = false
					that.loading.submit = false
					if ( data && data.status == 200){
						const error_room_id_string = data.data.error_room_id_array ? data.data.error_room_id_array.toString() : ''
						// swal.fire('Hoàn thành', `Đã tạo thành công ${data.data.success_count} hóa đơn tiền phòng.` + (error_room_id_string ? `Lỗi khi tạo phòng: ${error_room_id_string}` : ''), 'success')
						swal.fire('Thành công', 'Đã khóa sổ thành công', 'success')
						that.getPaymentData()
					} else {
						swal.fire('Lỗi', data.message || data.error.message, 'error')
					}
                }
			})
		},
		validateLockPayment(){
			if (this.items.some(item => !item.water.end || item.water.end == -1 || !item.electric.end == -1)){
				if (this.user_role === 'admin' && window.prompt('Số điện nước có vấn đề, nhập "trungsondeptrai" để khóa sổ') === "trungsondeptrai"){
					return true 
				} else {
					swal.fire('Thông báo', 'Vui lòng nhập đầy đủ số điện nước trước khi khóa sổ', 'info')
				}
				return false
			}
			return true
		},
		compareCsvData: function (data){
			this.items = this.items.map(bill => {
				const found_csv_bill = data.find(item => item.room_id && item.room_id.trim() == bill.room_id)
				if (found_csv_bill){
					found_csv_bill.diff_total_bill = bill.total_bill - found_csv_bill.total_bill
				} else found_csv_bill.diff_total_bill = -99999
				this.$set(bill, "csv_data", found_csv_bill);
				return bill
			})
		},
		exportCSV: function(){
			const rows = this.items.map(item => {
				return {
					"Tòa nhà": item.building,
					"Số phòng": item.room_id,
					"Họ và tên": item.name,
					"Đơn giá phòng": item.room_price,
					"Số ngày": item.date_count,
					"Tiền phòng": item.room_bill,
					"Đơn giá điện": item.electric_price,
					"Số điện đầu": item.electric.start,
					"Số điện cuối": item.electric.end,
					"Lượng điện": item.electric.end - item.electric.start,
					"Tiền điện": item.electric.total_bill,
					"Đơn giá nước": item.water_price,
					"Số nước đầu": item.water.start,
					"Số nước cuối": item.water.end,
					"Lượng nước": item.water.end - item.water.start,
					"Tiền nước": item.water.total_bill,
					"Tiền rác": item.trash_bill,
					"Tiền internet": item.internet.total_bill,
					"Tiền xe máy": item.motorbike.total_bill,
					"Tiền xe đạp": item.bike.total_bill,
					"Tiền máy giặt": item.washing_machine.total_bill,
					"Tiền máy lạnh": item.air_conditioner.total_bill,
					"Tổng cộng": item.total_bill,
				}
			})
			this.export_csv.rows = rows;
			this.export_csv.title = this.chosen_month + "-bang-tinh-tien";
			this.export_csv.trigger = !this.export_csv.trigger;
		}
	}
};
</script>
<style scoped>
    th {
        padding: 8px;
        border-bottom: 1px solid #ddd;
    }
</style>
